import { Grid, Typography } from '@mui/material';
import { usePqrFinalCausality } from './hook';
import { PqrFinalCausalityProps } from './props';
import AutocompleteField from '../../../../../components/general/fields/autocompleteField';
import { formatParams } from '../../../../../../shared/utils/params';

export const PqrFinalCausality = (props: PqrFinalCausalityProps) => {
    const { formik, causalities, motives, protections } =
        usePqrFinalCausality(props);

    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            pt="20px"
        >
            <Grid item xs={12}>
                <Typography style={{ fontWeight: 'bold', color: '#000' }}>
                    Causalidad final
                </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(causalities)}
                    label="Causalidad"
                    name="causality"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.causality}
                    errors={formik.errors.causality}
                    value={formik.values.causality}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('causality', value)
                    }
                    disabled={!props.isClousureStatus}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(motives)}
                    label="Motivo"
                    name="motive"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.motive}
                    errors={formik.errors.motive}
                    value={formik.values.motive}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('motive', value)
                    }
                    disabled={!props.isClousureStatus}
                />
            </Grid>
            <Grid item xs={12} md={4}>
                <AutocompleteField
                    data={formatParams(protections)}
                    label="Amparo"
                    name="protection"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.protection}
                    errors={formik.errors.protection}
                    value={formik.values.protection}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('protection', value)
                    }
                    disabled={!props.isClousureStatus}
                />
            </Grid>
        </Grid>
    );
};
